import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const UsersRoutes: RouteObject[] = [
  {
    path: ROUTES.USERS.LIST,
    element: (
      <PrivateRoute>
        <Pages.Users />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.USERS.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddUsers />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.USERS.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditUsers />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.USERS.VIEW(':id'),
    element: (
      <PrivateRoute>
        <Pages.ViewUsers />
      </PrivateRoute>
    ),
  },
]

export default UsersRoutes
